import type { KeyboardShortcut } from "./keyboard-shortcut";

export type GlobalScope = "global";

export type GlobalShortcut = KeyboardShortcut<GlobalScope>;

export const globalShortcuts = {
  OPEN_KEYBOARD_SHORTCUTS: {
    code: "Slash",
    keyLabel: "?",
    modifiers: ["shift"],
    scope: "global",
  },
} as const satisfies Record<string, GlobalShortcut>;
